const SWIcon = ({ className, icon, alt, height, width, parentClassName }) => {
  let style = null;
  if (height && width) {
    style = { height, width };
  }

  return (
    icon && (
      <div className={parentClassName}>
        <img className={className} src={icon} alt={alt} style={style} />
      </div>
    )
  );
};

SWIcon.defaultProps = {
  height: null,
  width: null,
  className: '',
  parentClassName: '',
};

export default SWIcon;
